import {observable, action} from 'mobx';
import {agentCharacteristicTypes} from './Agent'

class LocalizationStore {
    @observable.shallow
    locale = locales.en

    @action
    changeLocale(locale_key) {
        this.locale = locales[locale_key]
    }
}

const locales = {
    en: {
        en: 'English',
        ru: 'Russian',

        login: 'Login',
        logout: 'Logout',
        close: 'Close',
        cancel: 'Cancel',
        apply: 'Apply',
        accept: 'Accept',
        create: 'Create',
        add: 'Add',
        remove: 'Remove',
        success: 'Success',
        set_index: 'Set index',
        index_not_set: 'Index is not updated',
        wrong_index: 'Wrong index',
        agents: 'Agents',
        KPIs: 'KPIs',

        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',

        user_id: 'User id',
        identifier: 'Login',
        password: 'Password',
        tasks: 'Tasks',
        capacity: 'Capacity',
        currency: 'Currency',
        salary: 'Salary',
        description: 'Description',
        greetingMessage: 'Greeting message',
        task_description: 'Task description',
        task_input_title: 'Input title',
        status: 'Status',
        periodicalUpdatesInterval: 'Periodical updates interval',
        title: 'Title',
        option: 'Option',
        text: 'Text',
        multipleChoice: 'Multiple Choice',
        multiline: 'Multiline',
        label: 'Label',
        placeholder: 'Placeholder',
        goldenText: 'Golden Text',
        index: 'Index',
        task_interval_options: ['Once', 'Daily', 'Weekly', 'Bi-Weekly', 'Monthly', 'Quarterly'],

        active: 'Active',
        being_tested: 'Being tested',
        inactive: 'Inactive',

        textForm: 'Text Form',
        dropdownForm: 'Dropdown Form',
        checklistForm: 'Checklist Form',

        euro: 'Euro',


        drag_item: 'Drag items from list on the left',
        drop_zone: 'Drop form here',
        drop_file: 'You can drop configuration JSON file in the container above or ',
        select_file: 'click to select it',
        download_configuration: 'Download current configuration as JSON',
        empty_tasks_list: 'There is nothing to show',
        empty_agents_list: 'There is nothing to show',
        empty_kpi_list: 'There is nothing to show',
        no_agent: 'Select an agent from the list',
        change_avatar: 'Click or drop image to change',
        answer_options: 'Answer options (choose default)',

        remove_agent_question: 'Do you really want to remove this agent?',
        remove_task_question: 'Do you really want to remove this task?',
        confirm_action: 'Confirm you action',

        locale_changed: 'Locale changed',
        unknown_error: 'Some error occurred',
        task_created: 'Task has been successfully created',
        task_name_changed: 'Task name has been successfully changed',
        task_configuration_updated: 'Task configuration has been updated',
        task_removed: 'Task has been successfully removed',
        agent_prop_changed: 'Agent property has been changed',
        agent_created: 'Agent has been successfully created',
        agent_creation_reject: 'You cannot create an agent',
        agent_removed: 'Agent has been successfully removed',
        avatar_changed: 'Avatar has been successfully changed',
        wrong_credentials: 'Wrong login or password',
        characteristic_added: 'Characteristic added',
        characteristic_changed: 'Characteristic changed',
        characteristic_removed: 'Characteristic removed',
        characteristics: (type) => {
            switch (type) {
                case agentCharacteristicTypes.experiences:
                    return 'Experiences'
                case agentCharacteristicTypes.skills:
                    return 'Skills'
                case agentCharacteristicTypes.missions:
                    return 'Missions'
                case agentCharacteristicTypes.recentUpdates:
                    return 'Recent updates'
                case agentCharacteristicTypes.nextUpdates:
                    return 'Next updates'
                default:
                    throw Error('Unknown characteristic type')
            }
        },
        upload_logo: 'Upload logo',
        logo_uploaded: 'Logo uploaded',
        logo_deleted: 'Logo deleted',
        set_categories: 'Set categories',
        new_category: 'New category',
        all_categories: 'All categories',

        id: 'Id',

        warning_role_will_change: 'Making current user an agent will lead to the loss of privileges that come with {{role}} role.',
        warning_consider_creating_a_new_account: 'Consider creating an agent with the new user instead.'
    },
    ru: {
        en: 'Английский',
        ru: 'Русский',

        login: 'Войти',
        logout: 'Выход',
        close: 'Закрыть',
        cancel: 'Отмена',
        apply: 'Применить',
        accept: 'Принять',
        create: 'Создать',
        add: 'Добавить',
        remove: 'Удалить',
        success: 'Изменения успешно применены',
        set_index: 'Обновить индекс',
        index_not_set: 'Индекс не обновлен',
        wrong_index: 'Неверный индекс',
        agents: 'Агенты',
        KPIs: 'Статистика',

        day: 'День',
        week: 'Неделя',
        month: 'Месяц',
        year: 'Год',

        user_id: 'ID пользователя',
        identifier: 'Логин',
        password: 'Пароль',
        tasks: 'Задачи',
        capacity: 'Вместимость',
        currency: 'Валюта',
        salary: 'Зарплата',
        description: 'Описание',
        greetingMessage: 'Приветственное сообщение',
        task_description: 'Описание задачи',
        task_input_title: 'Заголовок формы',
        expanded_description: 'Развернутое описание',
        status: 'Статус',
        periodicalUpdatesInterval: 'Интервал обновлений',
        title: 'Заголовок',
        option: 'Вариант ответа',
        text: 'Текст',
        multipleChoice: 'Несколько вариантов ответа',
        multiline: 'Мультистоковое поле',
        label: 'Лейбл',
        placeholder: 'Плейсхолдер',
        goldenText: 'Эталонное значение',
        index: 'Index',
        task_interval_options: ['Один раз', 'Ежедневно', 'Еженедельно', 'Каждые 2 недели', 'Ежемесячно', 'Раз в квартал'],

        active: 'Активный',
        being_tested: 'Тестируется',
        inactive: 'Неактивный',

        textForm: 'Текстовое поле',
        dropdownForm: 'Выпадающий спиок',
        checklistForm: 'Чек-лист',

        euro: 'Евро',


        drag_item: 'Перетащите элементы из списка слева',
        drop_zone: 'Перетащите форму сюда',
        drop_file: 'Перетащите файл с конфигурацией в контейнер выше или ',
        select_file: 'выберите его',
        download_configuration: 'Загрузить текущую конфигурацию в формате JSON',
        empty_tasks_list: 'Список пуст',
        empty_agents_list: 'Список пуст',
        empty_kpi_list: 'Список пуст',
        no_agent: 'Выберите агента',
        change_avatar: 'Нажмите или перетащите изображение, чтобы изменить',
        answer_options: 'Варианты ответа (выберете значение по-умолчанию)',

        remove_agent_question: 'Вы действительно хотите удалить этого агента?',
        remove_task_question: 'Вы действительно хотите удалить эту задачу?',
        confirm_action: 'Подтвердите действие',

        locale_changed: 'Язык изменен',
        unknown_error: 'Произошла ошибка',
        task_created: 'Задача создана',
        task_name_changed: 'Название задачи изменено',
        task_removed: 'Задача удалена',
        agent_prop_changed: 'Свойство агента изменено',
        agent_created: 'Агент создан',
        agent_creation_reject: 'Вы не можете создать агента',
        agent_removed: 'Агент удален',
        avatar_changed: 'Аватар изменен',
        wrong_credentials: 'Неверный логин или пароль',
        characteristic_added: 'Характеристика добавлена',
        characteristic_changed: 'Характеристика изменена',
        characteristic_removed: 'Характеристика удалена',
        characteristics: (type) => {
            switch (type) {
                case agentCharacteristicTypes.experiences:
                    return 'Опыт'
                case agentCharacteristicTypes.skills:
                    return 'Навыки'
                case agentCharacteristicTypes.missions:
                    return 'Миссия'
                case agentCharacteristicTypes.recentUpdates:
                    return 'Недавние обновления'
                case agentCharacteristicTypes.nextUpdates:
                    return 'Планы'
                default:
                    throw Error('Unknown characteristic type')
            }
        },
        upload_logo: 'Загрузить лого',
        logo_uploaded: 'Лого загружено',
        logo_deleted: 'Лого удалено',
        set_categories: 'Категории',
        new_category: 'Новая категория',
        all_categories: 'Все категории',

        id: 'Идентификатор',

        warning_role_will_change: 'Преобразрвание текущего пользователя в агента приведёт к потере привилегий роли {{role}}.',
        warning_consider_creating_a_new_account: 'Рассмотрите возможность создания агента через аккаунт нового пользователя.'
    }
}

let firstKey = Object.keys(locales)[0]
Object.keys(locales).forEach(key => {
    if(Object.keys(locales[key]).length !== Object.keys(locales[firstKey]).length) {
        console.error(`Localization dictionaries length of '${key}' and '${firstKey}' are not the same`)
    }
})

var localizationStore = new LocalizationStore()

export {locales}
export default localizationStore



// WEBPACK FOOTER //
// ./src/store/LocalizationStore.js